<template>
  <div class="cta-section">
    <div class="layer">
      <MuxVideo
        mux-id="O5Rswh7AnTd7yXOJj1F5PR4ff9DOgm2oVafPLVcdLSo"
        :blur="true"
      />
    </div>
    <div class="cta-content">
      <h2>Ready to Transform Your Business?</h2>
      <p>
        Join agencies and photographers already using Travvir to deliver
        stunning virtual experiences
      </p>
      <div class="cta-buttons">
        <a class="primary-button" href="#partner-form">Apply for Partnership</a>
      </div>
    </div>
  </div>
</template>

<script setup>
import MuxVideo from "~/components/home/MuxVideo.vue";
</script>

<style lang="scss" scoped>
.cta-section {
  position: relative;
  padding: 6rem 2rem;
  text-align: center;

  .layer {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    width: 100%;
    height: 100%;
    filter: blur(200px);
  }

  @include respond-below(sm) {
    padding: 4rem 1rem;
  }

  .cta-content {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 100%;
    transform: translate(-50%, -50%);
    max-width: 800px;
    margin: 0 auto;
    z-index: 2;
    @include respond-below(sm) {
      position: relative;
      transform: unset;
      top: 0%;
      left: 0%;
      height: auto;
    }

    h2 {
      font-size: 42px;
      margin-bottom: 1.5rem;

      @include respond-below(sm) {
        font-size: 30px;
      }
    }

    p {
      font-size: 18px;
      margin-bottom: 2.5rem;
      color: rgba(255, 255, 255, 0.9);
    }

    .cta-buttons {
      display: flex;
      justify-content: center;
      gap: 1.5rem;

      @include respond-below(sm) {
        flex-direction: column;
        align-items: center;
        gap: 1rem;
      }

      button,
      a {
        text-decoration: none;
        padding: 0.9rem 1.8rem;
        border-radius: 8px;
        font-size: 18px;
        font-weight: 600;
        cursor: pointer;
        transition: transform 0.2s ease, box-shadow 0.2s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
        }

        &.primary-button {
          background: rgb(13, 13, 13);
          border: none;
          color: white;
        }
      }
    }
  }
}
</style>
